module.exports = __webpack_public_path__ + "static/media/doron_square.780d7d19.png";